import { render, staticRenderFns } from "./InvoiceCustomerList.vue?vue&type=template&id=1bf732fe"
import script from "./InvoiceCustomerList.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports